import Vue from "vue";
import Router from "vue-router";
import Hello from "@/components/Hello";
import Login from "@/components/Login";
import SignUp from "@/components/SignUp";
import ForgotPassword from "@/components/ForgotPassword";
import ForgotPasswordCode from "@/components/ForgotPasswordCode";
import NewPassword from "@/components/NewPassword";
import AddCard from "@/components/AddCard";
import ParkendaValet from "@/components/ParkendaValet";
import CurrentParking from "@/components/CurrentParking";
import Profile from "@/components/Profile";
import SelectCar from "@/components/RequestCar/SelectCar";
import SelectDropOff from "@/components/RequestCar/SelectDropOff";
import HistoryVehicles from "@/components/History/Vehicles";
import HistoryVehiclePlaces from "@/components/History/Places";
import HistoryVehiclePlaceDetails from "@/components/History/Details";
import RequestInProgress from "@/components/RequestCar/InProgress";
import CarReady from "@/components/RequestCar/CarReady";
import ParkingReceipt from "@/components/RequestCar/ParkingReceipt";
import ParkingReceiptFinal from "@/components/RequestCar/ParkingReceiptFinal";
import CardsList from "@/components/Cards/List";
import CardsListSquare from "@/components/Cards/ListSquare";
import CardAdd from "@/components/Cards/Add";
import CardAddSquare from "@/components/Cards/AddSquare";
import CardEdit from "@/components/Cards/Edit";
import CardEditSquare from "@/components/Cards/EditSquare";
import CarsList from "@/components/Cars/List";
import CarAdd from "@/components/Cars/Add";
import CarEdit from "@/components/Cars/Edit";
import LoyaltyAdd from "@/components/LoyaltyVouchers/Add";
import LoyaltyList from "@/components/LoyaltyVouchers/List";
import MarketCampagnsList from "@/components/MarketingCampaignVouchers/List";
import LoyaltyEdit from "@/components/LoyaltyVouchers/Edit";
import MarketCampagnsEdit from "@/components/MarketingCampaignVouchers/Edit";
import MarketCampagnsAdd from "@/components/MarketingCampaignVouchers/Add";
//import RegistrationAgreement from "@/components/RegistrationAgreement";
import ApplyLoyalty from "@/components/RequestCar/ApplyLoyalty";
import ApplyVoucher from "@/components/RequestCar/ApplyVoucher";
import SelectPayment from "@/components/RequestCar/SelectPayment";
import PayWithCreditCard from "@/components/RequestCar/PayWithCreditCard";
import PayWithSquareUpCreditCard from "@/components/RequestCar/PayWithSquareUpCreditCard";
import PayWithValetStand from "@/components/RequestCar/PayWithValetStand";
import PaymentProcessed from "@/components/RequestCar/PaymentProcessed";
import AddDoorJam from "@/components/Cars/AddDoorJam";
import FreeParking from "@/components/RequestCar/FreeParking";
import AppRating from "@/components/AppRating";
import WebRequestHello from "@/components/WebRequest/Hello";
import HowAreWeDoingSoFar from "@/components/WebRequest/HowAreWeDoingSoFar";
import ParkingPaid from "@/components/WebRequest/ParkingPaid";
import FastPaySquare from "@/components/Cards/FastPaySquare";
import SelectTag from "@/components/Residential/SelectTag";
import SelectLocation from "@/components/Residential/SelectLocation";
import TagDetails from "@/components/Residential/TagDetails";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "*",
      name: "Hello",
      component: Hello
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/signUp",
      name: "SignUp",
      component: SignUp
    },
    {
      path: "/forgotPassword",
      name: "ForgotPassword",
      component: ForgotPassword
    },
    {
      path: "/forgotPasswordCode",
      name: "ForgotPasswordCode",
      component: ForgotPasswordCode
    },
    {
      path: "/newPassword",
      name: "NewPassword",
      component: NewPassword
    },
    {
      path: "/parkendaValet",
      name: "ParkendaValet",
      component: ParkendaValet
    },
    {
      path: "/addCard",
      name: "AddCard",
      component: AddCard
    },
    {
      path: "/currentParking",
      name: "CurrentParking",
      component: CurrentParking
    },
    {
      path: "/profile",
      name: "Profile",
      component: Profile
    },
    {
      path: "/selectCar",
      name: "SelectCar",
      component: SelectCar
    },
    {
      path: "/selectDropOff",
      name: "SelectDropOff",
      component: SelectDropOff
    },
    {
      path: "/historyVehicles",
      name: "HistoryVehicles",
      component: HistoryVehicles
    },
    {
      path: "/historyVehiclePlaces",
      name: "HistoryVehiclePlaces",
      component: HistoryVehiclePlaces
    },
    {
      path: "/historyVehiclePlaceDetails",
      name: "HistoryVehiclePlaceDetails",
      component: HistoryVehiclePlaceDetails
    },
    {
      path: "/requestInProgress",
      name: "RequestInProgress",
      component: RequestInProgress
    },
    {
      path: "/carReady",
      name: "CarReady",
      component: CarReady
    },
    {
      path: "/parkingReceipt",
      name: "ParkingReceipt",
      component: ParkingReceipt
    },
    {
      path: "/parkingReceiptFinal",
      name: "ParkingReceiptFinal",
      component: ParkingReceiptFinal
    },
    {
      path: "/cardsList",
      name: "CardsList",
      component: CardsList
    },
    {
      path: "/cardsListSquare",
      name: "CardsListSquare",
      component: CardsListSquare
    },
    {
      path: "/cardEdit",
      name: "CardEdit",
      component: CardEdit
    },
    {
      path: "/cardEditSquare",
      name: "CardEditSquare",
      component: CardEditSquare
    },
    {
      path: "/cardAdd",
      name: "CardAdd",
      component: CardAdd
    },
    {
      path: "/cardAddSquare",
      name: "CardAddSquare",
      component: CardAddSquare
    },
    {
      path: "/carsList",
      name: "CarsList",
      component: CarsList
    },
    {
      path: "/carEdit",
      name: "CarEdit",
      component: CarEdit
    },
    {
      path: "/carAdd",
      name: "CarAdd",
      component: CarAdd
    },
    {
      path: "/loyaltyList",
      name: "loyaltyList",
      component: LoyaltyList
    },
    {
      path: "/marketCampagnsList",
      name: "marketCampagnsList",
      component: MarketCampagnsList
    },
    {
      path: "/marketCampagnsEdit",
      name: "MarketCampagnsEdit",
      component: MarketCampagnsEdit
    },
    {
      path: "/marketCampagnsAdd",
      name: "MarketCampagnsAdd",
      component: MarketCampagnsAdd
    },
    {
      path: "/loyaltyAdd",
      name: "LoyaltyAdd",
      component: LoyaltyAdd
    },
    {
      path: "/loyaltyEdit",
      name: "LoyaltyEdit",
      component: LoyaltyEdit
    },
    {
      path: "/applyLoyalty",
      name: "ApplyLoyalty",
      component: ApplyLoyalty
    },
    {
      path: "/applyVoucher",
      name: "ApplyVoucher",
      component: ApplyVoucher
    },
    // {
    //   path: "/registrationAgreement",
    //   name: "RegistrationAgreement",
    //   component: RegistrationAgreement
    // },
    {
      path: "/selectPayment",
      name: "SelectPayment",
      component: SelectPayment
    },
    {
      path: "/payWithValetStand",
      name: "PayWithValetStand",
      component: PayWithValetStand
    },
    {
      path: "/payWithCreditCard",
      name: "PayWithCreditCard",
      component: PayWithCreditCard
    },
    {
      path: "/payWithSquareUpCreditCard",
      name: "PayWithSquareUpCreditCard",
      component: PayWithSquareUpCreditCard
    },
    {
      path: "/paymentProcessed",
      name: "PaymentProcessed",
      component: PaymentProcessed
    },
    {
      path: "/addDoorJam",
      name: "AddDoorJam",
      component: AddDoorJam
    },
    {
      path: "/freeParking",
      name: "FreeParking",
      component: FreeParking
    },
    {
      path: "/appRating",
      name: "AppRating",
      component: AppRating
    },
    {
      path: "/webRequest",
      name: "WebRequestHello",
      component: WebRequestHello
    },
    {
      path: "/howAreWeDoingSoFar",
      name: "HowAreWeDoingSoFar",
      component: HowAreWeDoingSoFar
    },
    {
      path: "/parkingPaid",
      name: "ParkingPaid",
      component: ParkingPaid
    },
    {
      path: "/fastPaySquare",
      name: "FastPaySquare",
      component: FastPaySquare
    },
    {
      path: "/selectTag",
      name: "SelectTag",
      component: SelectTag
    },
    {
      path: "/selectLocation",
      name: "SelectLocation",
      component: SelectLocation
    },
    {
      path: "/tagDetails",
      name: "TagDetails",
      component: TagDetails
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js